import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { ICheckoutState, reducer as checkoutReducer } from './basket';
import {
  IDirectDebitState,
  reducer as directDebitReducer,
} from './direct-debit/';
import {
  IPostcodeChildTicketVerifyState,
  reducer as postcodeChildTicketVerifyReducer,
} from './postcode-child-ticket-verify';
import {
  IBookingSummaryState,
  reducer as bookingSummaryReducer,
} from '../reducers/booking-summary';
import { ICheckoutImageState, reducer as imageReducer } from './image';
import {
  ICompleteCheckoutState,
  reducer as completeCheckoutReducer,
} from './complete-checkout';

export const DATA_ACCESS_CHECKOUT_FEATURE_KEY = 'checkout';
export interface ICheckoutFeatureState {
  checkout: ICheckoutState;
  bookingSummary: IBookingSummaryState;
  directDebit: IDirectDebitState;
  image: ICheckoutImageState;
  postcodeChildTicketVerify: IPostcodeChildTicketVerifyState;
  completeCheckout: ICompleteCheckoutState;
}
export const reducers: ActionReducerMap<ICheckoutFeatureState> = {
  checkout: checkoutReducer,
  bookingSummary: bookingSummaryReducer,
  directDebit: directDebitReducer,
  image: imageReducer,
  postcodeChildTicketVerify: postcodeChildTicketVerifyReducer,
  completeCheckout: completeCheckoutReducer,
};

export const getCheckoutFeatureState =
  createFeatureSelector<ICheckoutFeatureState>(
    DATA_ACCESS_CHECKOUT_FEATURE_KEY
  );
